import { PropsWithChildren } from "react";
import { Box, Button, Paper } from "@mui/material";
import { FilterOutlined } from "@ant-design/icons";
import { IFilterModel } from "common/models/GridModels";
import { useLovelyGridContext } from "contexts/LovelyGridContext";
import {
  FieldValues,
  UseFormHandleSubmit,
  UseFormReset,
} from "react-hook-form";

type FilterContainerProps<TFilter extends IFilterModel> = {
  isSubmitting: boolean;
  handleSubmit: UseFormHandleSubmit<TFilter & FieldValues>;
  clearForm: UseFormReset<TFilter>;
};

export function FilterContainer<TFilter extends IFilterModel>({
  isSubmitting,
  handleSubmit,
  clearForm,
  children,
}: PropsWithChildren<FilterContainerProps<TFilter>>) {
  const { postModel, handleFiltering, handleClearFilter } =
    useLovelyGridContext<TFilter>();

  const applyFilter = handleSubmit((data) => {
    if (isSubmitting) return;
    handleFiltering(data);
  });

  return (
    <>
      {/* {JSON.stringify(postModel)} */}
      <Paper elevation={3} sx={{ p: 2 }}>
        <Box component="form" noValidate sx={{ mt: 1 }} onSubmit={applyFilter}>
          {children}
          <Button
            title="Filter"
            type="submit"
            variant="contained"
            sx={{ mt: 2, mr: 1 }}
            disabled={isSubmitting}
            // startIcon={<FilterOutlined />}
          >
            Search
          </Button>
          <Button
            title="Clear"
            type="reset"
            variant="contained"
            color="secondary"
            sx={{ mt: 2 }}
            onClick={() => {
              clearForm();
              handleClearFilter();
            }}
          >
            Clear
          </Button>
        </Box>
      </Paper>
    </>
  );
}
